import { HelpCircle } from 'lucide-react';

interface ClarifyingQuestionsProps {
  questions: string[];
  onQuestionClick: (question: string) => void;
}

/**
 * Displays a set of clickable clarifying question chips that the bot asks
 * when the user's query is too vague.  Clicking a chip populates the input
 * field so the user can answer it directly.
 */
export function ClarifyingQuestions({ questions, onQuestionClick }: ClarifyingQuestionsProps) {
  if (!questions || questions.length === 0) return null;

  return (
    <div className="mt-3">
      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-1">
        <HelpCircle size={12} />
        Please clarify
      </p>
      <div className="flex flex-wrap gap-2">
        {questions.map((question, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onQuestionClick(question)}
            className="
              inline-flex items-center px-3 py-1.5 rounded-full text-sm
              bg-blue-50 text-blue-700 border border-blue-200
              hover:bg-blue-100 hover:border-blue-300
              transition-colors cursor-pointer text-left
            "
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
}
